import { Business, Search, Location } from "@boxicons/react"
export function AboutABP() {
    return (
        <section className="dropdowns-box">
            <div className="dropdown">
                <div className="tittle-icon-box">
                    <h3>Nuestra empresa</h3>
                    <i class='bx bx-chevron-up'></i>
                </div>
                <div className="information-box">
                    <Business pack="filled" className="i-about" size="xl"/>
                    <p>
                        <br></br>
                        Iniciamos operaciones<br></br>
                        en Mayo de 2021,<br></br>
                        contamos con 5 años<br></br>
                        de expertis<br></br>
                        en el ramo industrial
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </p>
                </div>
            </div>
            <div className="dropdown">
                <div className="tittle-icon-box">
                    <h3>Objetivo</h3>
                    <i class='bx bx-chevron-up'></i>
                </div>
                <div className="information-box">
                    <Search size="xl" className="i-about"/>
                    <p>
                        <br></br>
                        Posicionarse en<br />
                        sectores especializados<br />
                        para la micro,<br />
                        pequeña y<br />
                        mediana empresa
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </p>
                </div>
            </div>
            <div className="dropdown">
                <div className="tittle-icon-box">
                    <h3>Ubicación</h3>
                    <i class='bx bx-chevron-up'></i>
                </div>
                <div className="information-box">
                    <Location pack="filled" size="xl" className="i-about"/>
                    <p>
                        <br></br>
                        Despacho D, Interior A, Piso 4<br></br>
                        Número exterior: 5060<br></br>
                        Av. López Mateos Sur<br></br>
                        Colonia Miguel de la Madrid Hurtado<br></br>
                        Zapopan, Jalisco, México
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </p>
                </div>
            </div>
        </section>
    )
}